import { Http } from '../../services/http';

export default function ({ numberOfRetries = 10, delay }) {

  let currentTryNo = numberOfRetries;
  let timeoutId;

  return (axiosInstance, method, params) => {
    if (timeoutId) {
      params.logData.tryNo = params.logData.tryNo - 1;
      window.clearTimeout(timeoutId);
    }

    return new Promise((resolve, reject) => {
      const axiosRetry = async () => {
        if (currentTryNo >= 1) {
          try {
            params.logData.tryNo = numberOfRetries - currentTryNo + 1;
            const response = await new Http(axiosInstance.get())[method](...Object.values(params)).then(resolve);
            currentTryNo = numberOfRetries;
            return response;
          } catch (err) {
            if (currentTryNo === 1) {
              currentTryNo = numberOfRetries;
              return reject(err);
            } else {
              timeoutId = setTimeout(() => axiosRetry(), delay);
            }
          }
        }
        currentTryNo = currentTryNo - 1;
      };

      return axiosRetry();
    });
  };


}
